// F1-1 全屏单图
import { FC, useMemo } from 'react'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import { IFullScreenSingleMedia, Theme } from '@/common/pd-meta-components-types'
import useScrollScale from '@/hooks/tools/use-scroll-scale'
import { useMobileDetector } from '@/hooks/use-mobile-detector'
import TitleAndDesc from '../../title-and-desc'
const FullScreenSingleMedia: FC<IFullScreenSingleMedia> = ({
  title,
  titleTag,
  desc,
  mediaUrl = '',
  mediaH5Url = '',
  theme,
  maskColor = 'transparent',
  maskDegree = 180,
}) => {
  const isMobile = useMobileDetector()
  const containerRef = useScrollScale({
    targetSelector: '.target-f1-1',
  })

  const maskClassName = useMemo(() => {
    if (title || desc) {
      switch (theme) {
        case Theme.Dark:
          return 'bg-gradient-to-b from-black/50'
        case Theme.Light:
          return 'bg-gradient-to-b from-white/50'
        default:
          return 'bg-gradient-to-b from-black/50'
      }
    }
    return ''
  }, [theme, title, desc])

  return (
    <div className={clsx('w-full h-fit relative', `pd-theme-${theme} bg-container-primary`)}>
      <div className={clsx('w-full', 'h-[177.86vw] laptop:h-[56.25vw] overflow-hidden')} ref={containerRef}>
        <PdMedia src={isMobile ? mediaH5Url || mediaUrl : mediaUrl} mask={false} className="target-f1-1 scale-200" />
      </div>
      <div
        className={clsx('absolute top-0 left-0 w-full h-[50%] pt-15 laptop:pt-28', maskClassName)}
        style={{
          background: `linear-gradient(${maskDegree}deg, ${maskColor}, transparent)`,
        }}
      >
        <TitleAndDesc title={title} desc={desc} titleTag={titleTag} />
      </div>
    </div>
  )
}

export default FullScreenSingleMedia
